import sentry from './sentry';
import wms from './wms';
import { RELEASES } from '~/constants/main';
import { appStore } from '~/mobx/appStore';
import { getMessageFromError } from '~/utils/formatter';
import { isCanceledRequest, isJestProject } from '~/helpers';
import { modalStore } from '~/mobx/modalStore';
import { IErrorModal } from '~/view/containers/Modals/ErrorModal';

class Logger {
  /**
   * Used to log errors into sentry, instead of console.log/info, also can show error modal.
   * Required to log in webview wrapper
   *
   * @param {{ error: any; place: string; showModal?: boolean; modalProps?: Partial<IErrorModal> }} { error, place, showModal, modalProps }
   * @memberof Logger
   */
  error = ({ error, place, showModal, modalProps }: { error: any; place: string; showModal?: boolean; modalProps?: Partial<IErrorModal> }) => {
    if (isJestProject()) return;
    if (isCanceledRequest(error)) return;

    if (appStore.settings?.release === RELEASES.PRODUCTION) {
      sentry.capture(error.response?.data?.message || 'request error', { place, error: JSON.stringify(error) });
    }

    if (showModal) {
      modalStore.openErrorModal({
        ...modalProps,
        message: getMessageFromError(error),
      });
    }

    this.log({ error, place });
  };

  /**
   * Used to log events instead of console.log/info.
   * Required to log in webview wrapper
   *
   * @param {...any} data
   * @memberof Logger
   */
  log = (...data: any) => {
    if (isJestProject()) return;

    if (window.IS_MOBILE) {
      wms.log(data);
    }

    console.info(data);
  };
}

const logger = new Logger();

export default logger;
